import COLORS from './colors'
import { CSSProperties } from 'react'
import { createUseStyles } from 'react-jss'

const commonStyles = {
  general: {
    buttonFormat: (additionalStyling) =>
      ({
        justifyContent: 'center',
        marginTop: '20px',
        width: '280px',
        borderRadius: '5px',
        ...additionalStyling,
      } as CSSProperties),
    commonText: {
      fontSize: '14px',
      textAlign: 'center',
      color: COLORS.dark,
    } as CSSProperties,
    infoTitle: (additionalStyling) =>
      ({
        fontSize: '20px',
        color: COLORS.greyscale.black,
        ...additionalStyling,
      } as CSSProperties),
    title: {
      color: COLORS.greyscale.dark,
      fontSize: '18px',
      lineHeight: '22px',
      textAlign: 'center',
      marginBottom: '12px',
    } as CSSProperties,
    subtitle: {
      color: COLORS.greyscale.dark,
      fontSize: '16px',
      lineHeight: '19px',
      textAlign: 'center',
      marginBottom: '14px',
    } as CSSProperties,
    content: {
      flexGrow: 1,
      padding: '20px',
      backgroundColor: COLORS.greyscale.white,
    } as CSSProperties,
    section: {
      paddingBottom: '26px',
      marginBottom: '16px',
      borderBottomWidth: '1px',
      borderBottomColor: COLORS.greyscale.medium,
    } as CSSProperties,
    shadow: 'rgba(0, 0, 0, 0.09) 1px 2px 8px 2px',
    buttonStyle: {
      fontSize: 16,
      fontWeight: 700,
      padding: 16,
      width: '100%',
      border: 'none',
      borderRadius: 4,
      boxShadow: '0px 0px 5px 1px rgba(0, 0, 0, 0.3)',
    } as CSSProperties,
  },
  announcementSteps: {
    button: {
      width: 82,
      height: 42,
    } as CSSProperties,
  },
}

// TODO: pass all commonStyles to here and update the components that uses commonStyles
export const useCommonStyles = createUseStyles({
  buttonStyle: {
    fontSize: 16,
    fontWeight: 700,
    padding: 16,
    width: '100%',
    border: 'none',
    borderRadius: 4,
    boxShadow: '0px 0px 5px 1px rgba(0, 0, 0, 0.3)',
  },
  title: {
    color: COLORS.greyscale.dark,
    fontSize: '18px',
    lineHeight: '22px',
    textAlign: 'center',
    marginBottom: '12px',
  },
  subtitle: {
    color: COLORS.greyscale.dark,
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center',
    marginBottom: '14px',
  },
  roundButtonsContainer: {
    margin: '8px 0',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  roundButtonLabel: {
    marginBottom: 16,
    marginLeft: 5,
    fontSize: 16,
    color: COLORS.greyscale.dark,
    fontWeight: 600,
  },
  // Google Maps Autocomplete
  addressInput: {
    boxSizing: 'border-box !important',
    fontFamily: 'Lato',
    fontSize: '16px',
    padding: '20px 14px',
    height: 60,
    width: '100%',
    marginTop: 15,
    borderRadius: 5,
    border: `2px solid ${COLORS.greyscale.medium}`,

    '&:focus': {
      outline: 'none',
      border: `2px solid ${COLORS.brand.primary}`,
    },
  },
  errorInputStyle: {
    '& input': {
      borderColor: COLORS.uiSpecific.danger,
    },
  },
  errorInputText: {
    fontSize: 13,
    color: COLORS.uiSpecific.danger,
    marginLeft: 5,
  },
  inputSelect: (props = {}) => ({
    width: '100%',
    border: `2px solid ${props.error ? COLORS.uiSpecific.danger : COLORS.greyscale.medium}`,
    background: 'white',
    height: 55,
    borderRadius: 5,
    color: COLORS.greyscale.dark,
    fontSize: 16,
    padding: '10px 0 10px 8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  contractSubtitle: {
    fontSize: 14,
  },
})

export default commonStyles
